import React from 'react';

// Owned by the admin bill-automation pages. The reporting copy went away with #3165 when that
// surface went live; these pages are still in development, so the notice stays with them.
export const WipBanner = () => /*#__PURE__*/React.createElement("div", {
  role: "alert",
  style: {
    background: '#fdecea',
    border: '2px solid #c43131',
    borderRadius: 8,
    padding: '14px 18px',
    marginBottom: 16,
    color: '#c43131',
    fontWeight: 800,
    fontSize: 18,
    lineHeight: 1.4,
    textAlign: 'center'
  }
}, "Work in progress \u2014 not ready for use yet. Reach out to mitch.zink@livable.com on Slack with any questions or concerns.");